export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}

export enum ExpressPaymentMethods {
    gpay = 'gpay',
    paypal = 'paypal',
}

export enum StatsigSynchronousInitializationExperimentVariant {
    unknown = 'unknown',
    control = 'control',
    test = 'test',
}

export enum PostCheckoutMandatoryQuestionsInAppVariant {
    optionalQuestionsInApp = 'optionalQuestionsInApp',
    optionalAndCannedQuestionsInApp = 'optionalAndCannedQuestionsInApp',
    customQuestionsInApp = 'customQuestionsInApp',
}

export enum FollowCardPlacementExperimentVariant {
    bottomFollowCard = 'bottom',
    topFollowCard = 'top',
}

export enum SHARE_TYPES {
    FACEBOOK = 'facebook',
    FACEBOOK_MESSENGER = 'facebookMessenger',
    TWITTER = 'twitter',
    EMAIL = 'email',
}

export enum ConfirmationPageReferralExperimentVariant {
    control = 'control',
    referralDrawer = 'referralDrawer',
    referralLinkout = 'referralLinkout',
}

export enum ExpressOnlyCheckoutExperimentVariant {
    notEnabled = 'notEnabled',
    enabled = 'enabled',
}

export enum EnhanceLogionOptionExperimentVariant {
    control = 'control',
    faster_experience = 'faster_experience',
    tickets_handy = 'tickets_handy',
    autofill_info = 'autofill_info',
}

export enum ScalableExpressCheckoutExperimentVariant {
    control = 'control',
    enabled = 'enabled',
}

export enum StripeElementsAustraliaExperimentVariant {
    control = 'noShowStripeElementsAustralia',
    newExperience = 'showStripeElementsAustralia',
}

export enum StripeElementsUnitedStatesExperimentVariant {
    control = 'noShowStripeElementsUnitedStates',
    newExperience = 'showStripeElementsUnitedStates',
}

export enum StripeElementsNewZealandExperimentVariant {
    control = 'noShowStripeElementsNewZealand',
    newExperience = 'showStripeElementsNewZealand',
}

export enum StripeElementsUKExperimentVariant {
    control = 'noShowStripeElementsUK',
    newExperience = 'showStripeElementsUK',
}

export enum StripeElementsCanadaExperimentVariant {
    control = 'noShowStripeElementsCanada',
    newExperience = 'showStripeElementsCanada',
}

export enum StripeElementsEuroExperimentVariant {
    control = 'noShowStripeElementsEuro',
    newExperience = 'showStripeElementsEuro',
}
